export default function WhyNeed() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            為什麼需要年度管理方案？
          </h2>
          <div className="w-20 h-1 bg-teal-500 mx-auto"></div>
        </div>
        
        <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-10 md:p-14 shadow-sm border border-gray-100">
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-6">
            多數網站的問題，<br />
            不是一開始沒做好，<br />
            <strong className="text-gray-900">而是做完之後沒有人負責</strong>。
          </p>
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-6">
            網站需要持續上線、維運、調整與處理細節，<br />
            這些工作並不會因為網站完成就消失。
          </p>
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
            年度管理方案的目的，<br />
            是確保這個網站在實際營運中，<br />
            <strong className="text-teal-600">一直有人處理、有人負責</strong>。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white rounded-xl p-8 border border-gray-200 hover:border-teal-200 transition-colors">
            <div className="w-14 h-14 bg-red-100 rounded-full flex items-center justify-center mb-4">
              <i className="ri-close-circle-line text-2xl text-red-600"></i>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-3">常見問題</h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              網站做完後無人維護<br />
              出問題找不到負責人<br />
              修改需要重新報價
            </p>
          </div>
          <div className="bg-white rounded-xl p-8 border border-gray-200 hover:border-teal-200 transition-colors">
            <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center mb-4">
              <i className="ri-checkbox-circle-line text-2xl text-teal-600"></i>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-3">我們的做法</h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              持續維運與代管<br />
              固定窗口可處理問題<br />
              基本調整納入服務
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
